import React from 'react';
import RadioList from './RadioList';
import { FieldValues, Path } from 'react-hook-form';
import { translate } from '../../services/translate';

function CameraManufacturerList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    return <RadioList items={['hikvision', 'dahua', 'intelbras'].map(type => ({
        label: translate(type),
        value: type,
    }))} name={name} clearValue={null} />;
}

CameraManufacturerList.getCount = RadioList.getCount;

export default CameraManufacturerList;
